<div class="tabbable__body rounded-top-right no-margin">
  <h3>Här kan du administrera tillgängliga beteendesegment</h3>

  @if (show.estimatesHaveChanged) {
    <import-warning></import-warning>
  }

  <dot-loader [visibility]="show.updatingEstimates"></dot-loader>

  <form #shareOfTotalForm="ngForm">
    <label>
      Andel av totallagret som ska vara tillgängligt för beteendesegmentsbokningar
    </label>
    <div class="save-total-lager-container">
      <div class="lager-input">
        <div class="input__container flex__container align-items--end">
          <input
            name="behaviorShareOfTotal"
            [(ngModel)]="shareOfTotal"
            wooPercentFormatter
            [wooMinValidator]="0"
            [wooMaxValidator]="1"
          />
        </div>
      </div>
      <div class="lager-button">
        <button
        class="button primary-1"
        (click)="updateShareOfTotal()"
        [disabled]="!shareOfTotalForm.valid || !saving"
        >
        Spara
      </button>
      @if(saving()) {
          <div class="spinner-grow text-danger" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
      }
      </div>
    </div>

    <div class="divider margin-top-bottom--2x"></div>

    <div class="container">
      <div class="left-item">
        <button class="button primary-1" 
          (click)="showNewBehavior()" 
          [scrollTo]="newBehaviorFormContainer">
          Nytt beteendesegment
        </button>

        @if (show.isEditing) {
          <button
            class="button primary"
            (click)="save()"
            [disabled]="behaviorValues.invalid"
          >
            Spara
          </button>
          <button class="link" (click)="cancelEditing()">
            Avbryt redigering
          </button>
        } @else {
          <button
            class="button secondary"
            (click)="setEditing(true)"
          >
            Redigera beteendesegment
          </button>
        }
      </div>
      <div class="right-item">
        <div class="display--flex">
          <div class="dropdown filter-dropdown margin-left--2x">
            <woo-dropdown
              [items]="behaviors"
              [(ngModel)]="selectedBehavior"
              name="selectedBehavior"
              inputId="select-behavior"
              labelText="Filtrera på Beteendesegment"
              notFoundText="Inga Beteendesegment hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
  
          @if (productFormats?.length > 1) {
            <div class="dropdown filter-dropdown margin-left--2x">
              <woo-dropdown
                [items]="productFormats"
                [(ngModel)]="selectedProductFormat"
                name="selectedProductFormat"
                inputId="select-product-format"
                labelText="Filtrera på Placering"
                [labelTransform]="translateProductFormat"
                notFoundText="Inga Placeringar hittades."
                [clearable]="true"
              ></woo-dropdown>
            </div>
          }
  
          @if (publishers?.length > 1) {
            <div class="dropdown filter-dropdown margin-left--2x">
              <woo-dropdown
                [items]="publishers"
                [(ngModel)]="selectedPublisher"
                name="selectedPublisher"
                inputId="select-publisher"
                labelText="Filtrera på Publicist"
                notFoundText="Inga publicister hittades."
                [clearable]="true"
              ></woo-dropdown>
            </div>
          }
        </div>
      </div>
    </div>
  </form>

  <div class="sticky-header">
    <h3>Tillgängliga beteendesegment</h3>
  </div>

  <table
    class="table table-woo table--info table--hover width--100"
    ngForm
    #behaviorValues="ngForm"
  >
    <thead class="sticky-table-head">
      <tr>
        <th [colSpan]="staticFields"></th>
        <th class="text-center" colspan="3">Estimatfördelning</th>
        <th class="text-center" colspan="3">Maxuttag</th>
      </tr>
      <tr>
        @for (header of tableHeaders; let index = $index; track index) {
          <th class="text--thin capitalize--first-letter">
            {{ header }}
          </th>
        }
      </tr>
    </thead>

    @if (!show.loading) {
      <tbody>
        @for (
          row of behaviorRows;
          let index = $index;
          track index
        ) {
          <tr [hidden]="!rowVisible(row)">
            <td class="text--thin vertical-align--middle">
              <span>{{ row.publisher }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ translateProductFormat(row.productFormat) }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ row.behavior }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ row.tag }}</span>
            </td>

            <td class="text--thin vertical-align--middle">
              @if (show.isEditing) {
                <div class="input__container">
                  <toggle
                    name="row-{{ index }}-active"
                    [(ngModel)]="getSpecificBehavior(row.behaviorId).active"
                  ></toggle>
                </div>
              } @else {
                <span>
                  {{
                    getSpecificBehavior(row.behaviorId).active
                      ? 'Ja'
                      : 'Nej'
                  }}
                </span>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.sharesPreroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-sharesPreroll"
                    [(ngModel)]="
                      getSpecificBehaviorShares(
                        row.behaviorId,
                        row.publisherId,
                        row.productFormatId
                      ).preroll
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="
                      includedProductFormatSlotTypes[row.productFormatId]
                        .preroll
                    "
                    [disabled]="
                      !includedProductFormatSlotTypes[row.productFormatId]
                        .preroll
                    "
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.sharesMidroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-sharesMidroll"
                    [(ngModel)]="
                      getSpecificBehaviorShares(
                        row.behaviorId,
                        row.publisherId,
                        row.productFormatId
                      ).midroll
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="
                      includedProductFormatSlotTypes[row.productFormatId]
                        .midroll
                    "
                    [disabled]="
                      !includedProductFormatSlotTypes[row.productFormatId]
                        .midroll
                    "
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.sharesPostroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-sharesPostroll"
                    [(ngModel)]="
                      getSpecificBehaviorShares(
                        row.behaviorId,
                        row.publisherId,
                        row.productFormatId
                      ).postroll
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="
                      includedProductFormatSlotTypes[row.productFormatId]
                        .postroll
                    "
                    [disabled]="
                      !includedProductFormatSlotTypes[row.productFormatId]
                        .postroll
                    "
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.withdrawalLimitsPreroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-limitsPreroll"
                    [(ngModel)]="
                      getSpecificBehaviorLimits(
                        row.behaviorId,
                        row.publisherId,
                        row.productFormatId
                      ).preroll
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="
                      includedProductFormatSlotTypes[row.productFormatId]
                        .preroll
                    "
                    [disabled]="
                      !includedProductFormatSlotTypes[row.productFormatId]
                        .preroll
                    "
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.withdrawalLimitsMidroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-limitsMidroll"
                    [(ngModel)]="
                      getSpecificBehaviorLimits(
                        row.behaviorId,
                        row.publisherId,
                        row.productFormatId
                      ).midroll
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="
                      includedProductFormatSlotTypes[row.productFormatId]
                        .midroll
                    "
                    [disabled]="
                      !includedProductFormatSlotTypes[row.productFormatId]
                        .midroll
                    "
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>{{ row.withdrawalLimitsPostroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-limitsPostroll"
                    [(ngModel)]="
                      getSpecificBehaviorLimits(
                        row.behaviorId,
                        row.publisherId,
                        row.productFormatId
                      ).postroll
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="
                      includedProductFormatSlotTypes[row.productFormatId]
                        .postroll
                    "
                    [disabled]="
                      !includedProductFormatSlotTypes[row.productFormatId]
                        .postroll
                    "
                  />
                </div>
              }
            </td>
          </tr>
        }
      </tbody>
    }
  </table>

  <dot-loader [visibility]="show.loading" [large]="true"></dot-loader>

  @if (show.isEditing) {
    <div class="margin-top--2x">
      <button
        class="button primary"
        (click)="save()"
        [disabled]="behaviorValues.invalid"
      >
        Spara
      </button>
      <button class="link" (click)="cancelEditing()">
        Avbryt redigering
      </button>
    </div>
  }

  <div #newBehaviorFormContainer>
    @if (show.newBehaviorForm) {
      <div class="sub-card col-12">
          <h3>Nytt beteendesegment</h3>
          <behavior-form
            (onAbort)="hideNewBehavior()"
            (onSubmit)="addBehavior($event)"
          ></behavior-form>
      </div>
    }
  </div>
</div>
